import * as React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import { IScreenSize, ViewType } from "@app/redux/reducers/settings";
import { useAppSelector } from "@app/redux/store";
import { IconComponent } from "@app/core";
import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";

import styles from "./tab-2025.module.scss";

export type OverviewTab2025 = {
  href: string;
  isSelected?: boolean;
  title: string;
  mobileTitle: string;
};

export type OverviewTabs2025Props = {
  tabs: OverviewTab2025[];
  className?: string;
};

const OverviewTabs2025: React.FC<OverviewTabs2025Props> = ({ tabs, className }) => {
  const screenSize = useAppSelector((s) => s.settings.screenSize);

  return (
    <div className={clsx(styles.root, className)}>
      <div className={clsx(styles.tabs, "uk-container")}>
        {tabs.map((tab, key) => (
          <Tab key={key} tab={tab} screenSize={screenSize} />
        ))}
      </div>
    </div>
  );
};

export { OverviewTabs2025 };

type TabProps = {
  tab: OverviewTabs2025Props["tabs"][number];
  screenSize?: IScreenSize;
};

const Tab: React.FC<TabProps> = ({ tab, screenSize }) => {
  const isMobile = screenSize && screenSize.viewType <= ViewType.Tablet;

  if (tab.isSelected) {
    return (
      <div className={clsx(styles.tab, styles.isSelected)}>
        <div className={clsx(styles.corner, styles.cornerLeft)} />
        <div className={clsx(styles.corner, styles.cornerRight)} />
        {isMobile ? tab.mobileTitle : tab.title}
      </div>
    );
  }

  return (
    <Link to={tab.href} className={clsx(styles.tab, tab.isSelected && styles.isSelected)}>
      {isMobile ? tab.mobileTitle : tab.title}
      <div className={styles.arrow}>
        <div className={styles.icon}>
          <IconComponent icon={IcnChevronRight} size="10px" />
        </div>
      </div>
    </Link>
  );
};
